import { Box, Flex } from 'components/elements'
import { TableItemRow, TableTd } from 'theme/globalStyleCss'
import {
  ShimmerCss,
  IconButtonCss,
  Tags1Css,
  Tags2Css,
  TagsNumberCss,
} from './styles'
import { AvatarShimmer } from 'components/shimmers/avatar'

export const InventoryShimmer = () => {
  return (
    <TableItemRow>
      <TableTd align={'center'}>
        <AvatarShimmer
          // showToggle={true}
          showIcon={true}
          iconStyle="square"
          iconSize="md"
        />
      </TableTd>
      <TableTd align={'center'}>
        <Box css={{ ...ShimmerCss, ...Tags1Css, mr: '$space$5' }}></Box>
      </TableTd>
      <TableTd align={'center'}>
        <Box css={{ ...ShimmerCss, ...Tags1Css, mr: '$space$5' }}></Box>
      </TableTd>
      <TableTd align={'center'}>
        <AvatarShimmer showToggle={true} showStatus={true} />
      </TableTd>
      <TableTd align={'center'}>
        <Flex align={'center'}>
          <Box css={{ ...ShimmerCss, ...Tags1Css, mr: '$space$5' }}></Box>
          <Box css={{ ...ShimmerCss, ...Tags2Css, mr: '$space$5' }}></Box>
          <Box css={{ ...ShimmerCss, ...TagsNumberCss }}></Box>
        </Flex>
      </TableTd>
      <TableTd align={'center'}>
        <Box css={{ ...ShimmerCss, ...Tags2Css, mr: '$space$5' }}></Box>
      </TableTd>
      <TableTd align={'center'}>
        <Flex justify={'end'}>
          <Box css={{ ...ShimmerCss, ...IconButtonCss, mr: '$space$5' }}></Box>
          <Box css={{ ...ShimmerCss, ...IconButtonCss }}></Box>
        </Flex>
      </TableTd>
    </TableItemRow>
  )
}
